import * as actionTypes from './actionTypes';

export const initKryPlase = () => {
    return {
        type: actionTypes.INIT_PLASE
    };
};

export const getPlase = (plase) => {
    return {
        type: actionTypes.GET_PLASE,
        plase: plase
    };
};

export const setPlase = (plase) => {
    return {
        type: actionTypes.SET_PLASE,
        plase: plase
    };
};

export const getPlaseFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_PLASE_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const kiesPlaas = (plaas) => {
    return {
        type: actionTypes.KIES_PLAAS,
        plaas: plaas
    };
};

export const centerPlaas = (plaas) => {
    return {
        type: actionTypes.CENTER_PLAAS,
        plaas: plaas
    };
};

export const initKryAlleBlokke = (seisoenid) => {
    return {
        type: actionTypes.INIT_ALLE_BLOKKE,
        seisoenid: seisoenid
    };
};

export const getAlleBlokke = (blokke) => {
    return {
        type: actionTypes.GET_ALLE_BLOKKE,
        blokke: blokke
    };
};

export const setAlleBlokke = (blokke) => {
    return {
        type: actionTypes.SET_ALLE_BLOKKE,
        blokke: blokke
    };
};

export const getAlleBlokkeFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_ALLE_BLOKKE_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const initKryBlokke = (plaasid, seisoenid) => {
    return {
        type: actionTypes.INIT_BLOKKE,
        plaasid: plaasid,
        seisoenid: seisoenid
    };
};

export const getBlokke = (blokke) => {
    return {
        type: actionTypes.GET_BLOKKE,
        blokke: blokke
    };
};

export const setBlokke = (blokke) => {
    return {
        type: actionTypes.SET_BLOKKE,
        blokke: blokke
    };
};

export const getBlokkeFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_BLOKKE_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const kiesBlok = (blok) => {
    return {
        type: actionTypes.KIES_BLOK,
        blok: blok
    };
};

export const initKryPlaas = (plaasid) => {
    return {
        type: actionTypes.INIT_PLAAS,
        plaasid: plaasid
    };
};

export const getPlaas = (plaas) => {
    return {
        type: actionTypes.GET_PLAAS,
        plaas: plaas
    };
};

export const setPlaas = (plaas) => {
    return {
        type: actionTypes.SET_PLAAS,
        plaas: plaas
    };
};

export const getPlaasFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_PLAAS_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const initKryBlok = (blokid) => {
    return {
        type: actionTypes.INIT_BLOK,
        blokid: blokid
    };
};

export const getBlok = (blok) => {
    return {
        type: actionTypes.GET_BLOK,
        blok: blok
    };
};

export const setBlok = (blok) => {
    return {
        type: actionTypes.SET_BLOK,
        blok: blok
    };
};

export const getBlokFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_BLOK_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const getEenheidVerhoudings = () => {
    return {
        type: actionTypes.GET_EENHEIDVERH
    };
};

export const setEenheidVerhoudings = (data) => {
    return {
        type: actionTypes.SET_EENHEIDVERH,
        data: data
    };
};

export const getEenheidVerhoudingsFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_EENHEIDVERH_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};